import React, { useState, useCallback } from 'react'
import { ErrorMessage } from '../../../../../../Components/Form'
import SubmitButton from '../../../../../../Components/Form/SubmitButton'
import { createUserProfileLog, sendWarningGQL } from '../../gql'
import { authorization } from '../../../../../../Module/Auth/Auth'
import { USER_PROFILE_LOGS_TYPE } from '../../../../../../constants'

const SendWarningButton = ({ recipientId, count = 0 }) => {
  const [warningsCount, setWarningsCount] = useState(count)
  const [errorMessage, setErrorMessage] = useState(null)
  const [loading, setLoading] = useState(false)
  const user = authorization.getUser()

  const sendWarning = useCallback(async () => {
    try {
      setLoading(true)
      setErrorMessage(null)
      const req = await sendWarningGQL({ recipientId })
      const res = await req.json()
      await createUserProfileLog({
        input: {
          profile_user_id: +recipientId,
          actioned_by_user_id: +user.id,
          type: USER_PROFILE_LOGS_TYPE.WARNING,
        },
      })
      if (res.error) {
        setErrorMessage(res.error)
      }
      setWarningsCount(warningsCount + 1)
    } catch (error) {
      setErrorMessage(error.message)
    } finally {
      setLoading(false)
    }
  }, [recipientId])

  return (
    <div>
      <SubmitButton disabled={loading} onClick={sendWarning}>
        {loading ? 'Sending...' : `⚠️ Warning (${warningsCount})`}
      </SubmitButton>
      {errorMessage ? <ErrorMessage message={errorMessage} /> : null}
    </div>
  )
}

export default SendWarningButton
